
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.025 2.56a2.093 2.093 0 00-1.461.669 2.096 2.096 0 00-.562 1.508v22.527a2.096 2.096 0 001.226 1.987c.251.115.521.18.797.19h24.782a2.846 2.846 0 002.714-2.458l2.432-12.647a3.179 3.179 0 00-.667-2.559 2.664 2.664 0 00-2.047-.984h-1.716V7.9a2.115 2.115 0 00-1.997-2.151H14.569a1.165 1.165 0 01-.807-.333l-2.341-2.213a2.22 2.22 0 00-1.523-.641zm0 1.281h7.872a.895.895 0 01.64.268l2.341 2.213a2.464 2.464 0 001.69.68h10.931c.216.023.416.129.555.297s.208.382.187.599v2.893H8.719a2.666 2.666 0 00-2.56 2.227L3.427 27.97l-.035.19H2.025c-.216-.023-.416-.129-.555-.297s-.208-.382-.187-.599V4.737a.829.829 0 01.742-.896zm6.923 8.228h20.287a1.365 1.365 0 011.062.526 1.93 1.93 0 01.397 1.55l-2.442 12.632a1.567 1.567 0 01-1.448 1.383H4.699l2.804-14.72c.04-.362.21-.697.474-.948s.607-.4.971-.422z"}})])
          )
        }
      }
    